import { convertAnyToKg } from "./weightConversion";

export const calculateTotalWeight = (packaging: PackagingData): PackagingData => {
  if (!packaging) return packaging;
  let totalWeightBaseUnit = 0;
  let totalWeightSalesOfPack = 0;
  let totalWeightBulkPack = 0;
  let totalWeightTransportUnitPack = 0;

  const baseUnitWeight = convertAnyToKg(
    Number(packaging.unitSizeWeightUnit),
    Number(packaging.unitSize)
  );
  totalWeightBaseUnit = baseUnitWeight || 0;

  for (const singleUnitPackaging of packaging.singleUnitPackaging) {
    const weight = convertAnyToKg(
      Number(singleUnitPackaging.weightUnit),
      Number(singleUnitPackaging.materialWeight || 0)
    );
    totalWeightBaseUnit += Number(weight);
  }

  totalWeightSalesOfPack = totalWeightBaseUnit * (packaging.numberOfBaseUnits || 1);
  for (const salesUnitPackaging of packaging.salesUnitPackaging) {
    const weight = convertAnyToKg(
      Number(salesUnitPackaging.weightUnit),
      Number(salesUnitPackaging.materialWeight || 0)
    );
    totalWeightSalesOfPack += Number(weight);
  }

  totalWeightBulkPack = totalWeightSalesOfPack * (packaging.numberOfPacks || 1);
  for (const bulkUnitPackaging of packaging.bulkUnitPackaging) {
    const weight = convertAnyToKg(
      Number(bulkUnitPackaging.weightUnit),
      Number(bulkUnitPackaging.materialWeight || 0)
    );
    totalWeightBulkPack += Number(weight);
  }

  totalWeightTransportUnitPack = totalWeightBulkPack * (packaging.numberOfCases || 1);
  for (const transportUnitPackaging of packaging.transportUnitPackaging) {
    const weight = convertAnyToKg(
      Number(transportUnitPackaging.weightUnit),
      Number(transportUnitPackaging.materialWeight || 0)
    );
    totalWeightTransportUnitPack += Number(weight);
  }

  return {
    ...packaging,
    totalWeightBaseUnit,
    totalWeightSalesOfPack,
    totalWeightBulkPack,
    totalWeightTransportUnitPack
  };
};
